  // Format timestamp to readable date
  export const formatTimestamp = (timestamp: number | string | Date) => {
    const date = timestamp instanceof Date ? timestamp : new Date(timestamp)
    if (Number.isNaN(date.getTime())) return '—'
    return date.toLocaleString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
    })
  }

  // Format duration in milliseconds to readable format
  export const formatDuration = (ms: number) => {
    const seconds = Math.floor(ms / 1000)
    const minutes = Math.floor(seconds / 60)
    const remainingSeconds = seconds % 60
    return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`
  }

  /** Format a Date or ISO string as "Mar 5, 2026". Returns "—" for null/invalid. */
  export function formatDate(date: Date | string | null | undefined): string {
    if (!date) return '—'
    const d = typeof date === 'string' ? new Date(date) : date
    if (Number.isNaN(d.getTime())) return '—'
    return d.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    })
  }

  /** Convert camelCase / snake_case keys to Title Case ("riskStatement" → "Risk Statement"). */
  export function humanizeKey(key: string): string {
    return key
      .replace(/_/g, ' ')
      .replace(/([A-Z])/g, ' $1')
      .replace(/^./, (c) => c.toUpperCase())
      .trim()
  }

  /** Compact relative time: "just now", "5m", "3h", "2d", or "Mar 5". */
  export function relativeTime(date: Date | string, options?: { suffix?: boolean }): string {
    const diffMs = Date.now() - new Date(date).getTime()
    const mins = Math.floor(diffMs / 60_000)
    const suffix = options?.suffix ? ' ago' : ''
    if (mins < 1) return 'just now'
    if (mins < 60) return `${mins}m${suffix}`
    const hours = Math.floor(mins / 60)
    if (hours < 24) return `${hours}h${suffix}`
    const days = Math.floor(hours / 24)
    if (days < 7) return `${days}d${suffix}`
    return new Date(date).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
  }

export function getGreetingsByTime(includeEmoji = true): string {
  const hours = new Date().getHours()
  const [greeting, emoji] = hours < 12
    ? ['Good morning', '🌅']
    : hours < 18
      ? ['Good afternoon', '☀️']
      : ['Good evening', '🌙']
  return includeEmoji ? `${greeting} ${emoji}` : greeting
}
